<template>
<div class="container">

    <div class="py-5 text-center">
        <h2>Unterstützungserklärung für die Nationalrats&shy;wahl am 29. September</h2>

        <div class="wahlzettel">
            <img src="@/assets/vote.png" alt="Grüne - 10, Maria Chlastak" title="Grüne - 10, Maria Chlastak" />
        </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style>
    .wahlzettel {
        text-align: center;
    }
    .wahlzettel img {
        width: 100%;
        max-width: 777px;
    }
</style>
